import { HStack, Pressable } from "native-base";
import { Svg } from "react-native-svg";
import { backButtonSVG } from "../../utils/svg";

const BackButton = ({ onPress = () => {} }) => {

  return (
    <HStack space={3} alignItems="center">
      <Pressable onPress={onPress}>
        <Svg width="30" height="36" viewBox="0 0 36 36">
          {backButtonSVG}
        </Svg>
      </Pressable>
    </HStack>
  );
};

export default BackButton;
